/**
 * Desktop Navigation Component
 *
 * Desktop navigation menu with dropdowns and phone CTA.
 *
 * Client Component: Uses NavigationMenu (Radix UI) for interactive dropdowns.
 */

"use client";

import Link from "next/link";
import {
	NavigationMenu,
	NavigationMenuItem,
	NavigationMenuLink,
	NavigationMenuList,
} from "@/components/ui/navigation-menu";
import { PhoneButton } from "@/components/ui/phone-button";
import type { Navigation, SiteMetadata } from "@/lib/validation";

interface DesktopNavProps {
	navigation: Navigation;
	siteMetadata: SiteMetadata;
}

export function DesktopNav({ navigation, siteMetadata }: DesktopNavProps) {
	return (
		<nav className="hidden lg:flex items-center space-x-6">
			<NavigationMenu>
				<NavigationMenuList className="space-x-1">
					{navigation.mainMenu.map((item) => (
						<NavigationMenuItem key={item.href}>
							<NavigationMenuLink asChild>
								<Link
									href={item.href}
									className="text-foreground-dark hover:text-primary bg-transparent hover:bg-background-dark/50 px-4 py-2 rounded-md transition-colors font-medium text-sm"
								>
									{item.label}
								</Link>
							</NavigationMenuLink>
						</NavigationMenuItem>
					))}
				</NavigationMenuList>
			</NavigationMenu>

			{/* Phone CTA - Desktop: /contact, Mobile: tel: link */}
			<PhoneButton
				phoneNumber={siteMetadata.sitePhone}
				variant="default"
				size="default"
			/>
		</nav>
	);
}
